import { render, staticRenderFns } from "./ErrorModal.vue?vue&type=template&id=745c6a04&"
import script from "./ErrorModal.vue?vue&type=script&lang=js&"
export * from "./ErrorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports